// extracted by mini-css-extract-plugin
export default {"table_wrapper":"Example_table_wrapper__15Yqk","editInput":"Example_editInput__gJXCV","fl_table":"Example_fl_table__sBF6m"};